"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = void 0;
const assert_1 = __importDefault(require("assert"));
const math_1 = require("./lib/math");
/**
 * Map x to its permuted value x' in `domain`. The permutation is deterministic
 * on `seed`.
 * @param x Original value to permute
 * @param domain Domain of x that this function bijectively maps over
 * @param seed Secure pseudorandom number to be used as the seed
 * @param rounds Number of Feistel rounds to apply; consider setting to >=4
 *  We cheat here by rejecting odd rounds
 * @param f Feistel round function that produces a hash
 * @returns permuted value x'
 */
function encrypt(x, domain, seed, rounds, f) {
    (0, assert_1.default)(domain !== 0n, 'modulus must be > 0');
    (0, assert_1.default)(x < domain, 'x too large');
    (0, assert_1.default)((rounds & 1n) === 0n, 'rounds must be even');
    const h = (0, math_1.usqrt)((0, math_1.nextPerfectSquare)(domain));
    do {
        let L = x % h;
        let R = x / h;
        for (let i = 0n; i < rounds; i++) {
            const nextR = (L + f(R, i, seed, domain)) % h;
            L = R;
            R = nextR;
        }
        x = h * R + L;
    } while (x >= domain);
    return x;
}
exports.encrypt = encrypt;
/**
 * Inverse-map x' to its original value x in `domain`. Use the same `seed` that
 * was used to originally permute x.
 * @param xPrime Permuted value value x'
 * @param domain Domain of x that this function bijectively maps over
 * @param seed Secure pseudorandom number to be used as the seed
 * @param rounds Number of Feistel rounds to apply; consider setting to >=4
 *  We cheat here by rejecting odd rounds
 * @param f Feistel round function that produces a hash
 * @returns original value x
 */
function decrypt(xPrime, domain, seed, rounds, f) {
    (0, assert_1.default)(domain !== 0n, 'modulus must be > 0');
    (0, assert_1.default)(xPrime < domain, 'x too large');
    (0, assert_1.default)((rounds & 1n) === 0n, 'rounds must be even');
    const h = (0, math_1.usqrt)((0, math_1.nextPerfectSquare)(domain));
    do {
        let L = xPrime % h;
        let R = xPrime / h;
        for (let i = 0n; i < rounds; i++) {
            const nextL = (R + h - (f(L, rounds - i - 1n, seed, domain) % h)) % h;
            R = L;
            L = nextL;
        }
        xPrime = h * R + L;
    } while (xPrime >= domain);
    return xPrime;
}
exports.decrypt = decrypt;
